<template>
  <div class="row-edit">
    <div class="row-edit-badge">
      <div class="row-edit-badge-section">
        <div class="list-float-header">
          <div class="float-left w220">
          </div>
          <div class="date-time float-left">
            <div class="w220">
              <label>{{$t('INDENT_EXPECTED_DATE')}}</label>
            </div>
          </div>
        </div>
        <div class="list-float" v-for="(consignee,index) in consignees" :key="index">
         <div class="float-left w220">
            <Ellipsis :text="consignee.details.name" :length="20"/>
          </div>
          <div class="date-time float-left">
            <DatePicker
              v-model="consignee.expected_delivery"
              :picker-options="getPickerOptions()"
              :clearable="false"
              type="datetime"
              format="dd-MM-yyyy hh:mmA"
              :placeholder="$t('INDENT_SELECT')"
              class="w175">
            </DatePicker>
          </div>
        </div>
    </div>
    <button class="btn-primary-outline" @click="onSubmit">{{$t('INDENT_SUBMIT')}}</button>
  </div>
  </div>
</template>

<script>
import { uniqBy } from 'lodash';
import moment from 'moment';

export default {
  props: ['order'],

  data() {
    return {
      payload: [],
      consignees: [],
    };
  },
  created() {
    this.consignees = uniqBy(this.order.destinations, 'location_id');
  },
  methods: {
    async onSubmit() {
      try {
        let payload = this.consignees.filter(val => val.expected_delivery);
        payload = payload.map(val => ({
          location_id: val.location_id,
          expected_delivery_at: moment(val.expected_delivery).toISOString(),
        }));
        const id = this.order.order_number;
        const result = await this.$store.dispatch('order/updateEdd', {
          id,
          data: payload,
        });
        if (result.order_number) {
          this.$emit('done', 'updateEdd');
          this.$success({
            message: this.$t('INDENT_UPDATE_SUCCESS_MSG'),
          });
        }
        return result;
      } catch (e) {
        return e;
      }
    },
    getPickerOptions() {
      const loadingDate = new Date(this.$moment(this.order.sources[0].loading_date)) || new Date();
      if (this.order.order_type === 1) {
        loadingDate.setHours(0, 0, 0, 0);
      }
      return {
        disabledDate(time) {
          if (loadingDate) {
            return time.getTime() < loadingDate.getTime();
          }
        },
      };
    },
  },
};
</script>
